<template>
  <div class="agreement">
    <div class="agreementTitle">来来车服平台隐私政策</div>
    <div class="agreementmesg">● 个人信息指以电子或者其它形式记录的能够单独或者与其它信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</div>
              <div class="agreementmesg">● 为了注册、登录来来车服，开发者将在获取你的明示同意后，收集你的微信昵称、头像。</div>
              <div class="agreementmesg">● 为了快速填写地址，开发者将在获取你的明示同意后，收集你的位置信息。</div>
              <div class="agreementmesg">● 开发者收集你选中的照片或视频信息，用于生成并保存海报图。</div>
              <div class="agreementmesg">● 开发者使用你的通讯录 (仅写入) 权限，用于快递师傅与您取得联系，也用于客服需要与您确认信息的时候取得联系。</div>
              <div class="agreementmesg">● 开发者收集你的发布内容，用于工作人员对您的需求进行策划分析。</div>
              <div class="agreementmesg">● 客服电话：<a :href="'tel:' + phoneNumber">{{phoneNumber}}</a></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        phoneNumber: '',
      }
    },
    created() {
      this.phoneNumber  = sessionStorage.getItem("phoneNumber")
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style scoped="scoped">
  .agreement {
    width: calc(100% - 40px);
   /* // margin: 20px; */
    padding: 20px;
    background-color: #FFFFFF;
  }

  .agreementTitle {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 20px;
  }

  .agreementmesgtitle {
    font-size: 14px;
    font-weight: bold;
  }

  .agreementmesgtitlexie {
    font-size: 14px;
    font-weight: bold;
/*    // font-style: italic; */
    text-decoration: underline
  }

  .agreementmesg {
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/privacyAgreement.vue